import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgUploaderModule } from 'ngx-uploader';


import {SellerDashboardComponent} from './seller-dashboard.component';
import {SellerDashboardService} from './seller-dashboard.service';
import {DeviceConfigurerServiceSharedModule} from '../../shared/shared.module';
import {sellerDashboardRoute} from './seller-dashboard.route';
import { SellerModelComponent } from './seller-model.component';
import { SellerChartComponent } from './seller-chart.component';
import { SellerModelImageComponent } from './seller-model-image.component';
import { SellerFileComponent } from './seller-file.component';

@NgModule( {
    imports: [
        DeviceConfigurerServiceSharedModule,
        NgUploaderModule,
        CommonModule,
        RouterModule.forRoot( sellerDashboardRoute, { useHash: true } )
    ],
    declarations: [
        SellerDashboardComponent,
        SellerModelComponent,
        SellerChartComponent,
        SellerModelImageComponent,
        SellerFileComponent
    ],
    exports: [
        SellerDashboardComponent
    ],
    providers: [
        SellerDashboardService
    ]
} )
export class SellerDashboardModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/seller-dashboard/seller-dashboard.module.ts